import { checkPermission } from "library/authorization/index.mjs"

export function hasDemand(demand) {
    return checkPermission(demand)
}
